import React from 'react';
import PropTypes from 'prop-types';
import styles from "./TextArea.scss";


const TextArea = ({name, onChange, placeholder, value, maxLength, error, className, id, onBlur}) => {
	let classNameInner = (className === "") ? styles.default : className;
	return (
		<div className={styles.container}>
			<textarea
				id={id}
				className={`${classNameInner} ${(error) ? styles.hasError : ''}`}
				name={name}
				placeholder={placeholder}
				value={value}
				maxLength={maxLength}
				onChange={onChange}
				onBlur={onBlur}/>
			{error && <div className={styles.error}>{error}</div>}
		</div>
	);
};
TextArea.defaultProps = {
	type: 'text',
	className: '',
	maxLength: null
};
//
TextArea.propTypes = {
	name: PropTypes.string,
	onChange: PropTypes.func,
	onBlur: PropTypes.func,
	placeholder: PropTypes.string,
	value: PropTypes.string,
	maxLength: PropTypes.number,
	error: PropTypes.string,
	className: PropTypes.string,
	id: PropTypes.string
};
//
export default TextArea;